const Loading = () => {
  return (
    <div className="init-loading-container">
      <div className="lds-dual-ring">
      </div>
    </div>
  );
};

export default Loading;
